module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.list), function(i) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/rangeDetails/' + i.rankid
      }
    }, [_c('div', {
      staticClass: "imgcontainer"
    }, [_c('img', {
      attrs: {
        "src": i.imgurl,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v("爱乐")])]), _vm._v(" "), _c('div', [_c('h5', {
      domProps: {
        "textContent": _vm._s(i.rankname)
      }
    })]), _vm._v(" "), _vm._m(0, true)])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tb"
  }, [_c('img', {
    attrs: {
      "src": require("../img/arrow_icon.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b1598f"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/r_content.vue
// module id = 267
// module chunks = 0